module.exports = __webpack_public_path__ + "img/CUADRO_Esp-Tecnicas-SMART-SCAN.72a414aa.png";